import styles from './styles.module.css';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import React, { CSSProperties, ReactNode } from 'react';
import { CaretIcon } from 'src/icons/caret';

interface Props {
	title: string;
	children: ReactNode;
	style?: CSSProperties;
	link: {
		internalLink?: string;
		externalLink?: string;
		isDownload?: boolean;
	};
}

export const InfoLink = (props: Props) => {
	const { title, children, style, link } = props;

	const contentJsx = (
		<>
			<div className={styles.title}>
				{title} <CaretIcon />
			</div>
			<div className={styles.text}>{children}</div>
		</>
	);

	if (link.internalLink && !link.isDownload) {
		return (
			<AnchorLink
				className={styles.wrapper}
				gatsbyLinkProps={{ style }}
				to={link.internalLink || '/'}
			>
				{contentJsx}
			</AnchorLink>
		);
	} else {
		const linkTo = link.internalLink || link.externalLink || '/';
		return (
			<a
				className={styles.wrapper}
				style={style}
				href={linkTo}
				download={link.isDownload}
				target="_blank"
			>
				{contentJsx}
			</a>
		);
	}
};
